<template>
	<transition name="fade" v-if="config.show">
		<div class="modal-box">
			<div class="modal p-0">
				<div class="modal-header clearfix">
					<h2 class="pull-left">
						팝업 수정
					</h2>
					<a class="close" @click="config.show=false">&times;</a>
				</div>
				<div class="modal-body p-15 clearfix">
					<table class="m-t-30 full-width table-condensed table-bordered text-center m-t-0 m-b-0" style="border:1px solid #ddd;">
						<tbody>
							<tr>
								<th class="bg-lightgray">제목</th>
								<td>
									<input class="form-control-sm full-width round m-b-0" type="text" v-model="popupData.title">
								</td>
							</tr>
							<tr>
								<th class="bg-lightgray">노출여부</th>
								<td>
									<select class="form-control-sm full-width round m-b-0" v-model="popupData.showEnable">
										<option value="1">노출</option>
										<option value="0">노출안함</option>
									</select>
								</td>
							</tr>
							<tr>
								<th class="bg-lightgray">노출위치</th>
								<td>
									<div class="input-group">
										<span class="input-group-addon w140 v-mid p-r-10">
											<input id="check-1" class="checkbox3-sm" type="checkbox" name="student" v-model="popupData.posCenterEnable">
											<label for="check-1" class="v-mid full-width m-0">가운데정렬</label>
										</span>
										<span class="input-group-addon p-r-5">
											x : <input class="form-control-sm round m-b-0 w60 inline" type="text" v-model="popupData.posX">
										</span>
										<span class="input-group-addon">
											y : <input class="form-control-sm round m-b-0 w60 inline" type="text" v-model="popupData.posY">
										</span>
									</div>
								</td>
							</tr>
							<tr>
								<th class="bg-lightgray">내용</th>
								<td>
									<div class="text-edit">
										<textarea class="full-width editorContent" cols="30" rows="4"></textarea>
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="modal-footer p-10">
					<button class="btn bg-deepblue text-white full-width m-t-30 round" type="button" @click="patchPopup">저장</button>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import Axios from 'axios';
import server from '../statics/server';
export default {
	name: "ModalPopupModify",
	mounted: async function() {
	},
	default: function() {
		return {
			name: this.name,
			show: false
		}
	},
	props: {
		config: Object,
		popup: Object
	},
	data:function() {
		return {
			popupData: {
				title: "",
				showEnable: 1,
				posCenterEnable: false,
				posX: 0, posY: 0,
				content: ""
			},
			editorContent: null
		}
	},
	methods: {
		editorInit: async function() {
				// eslint-disable-next-line
			let that = this;

			await window.tinymce.init({	selector: '.editorContent' });	
			await window.tinymce.init({
				selector: '.editorContent',
				height: 450,
				branding: false,
				plugins: [
					"autoresize",
					"advlist autolink lists link image charmap print preview anchor",
					"searchreplace visualblocks code fullscreen",
					"insertdatetime media table paste imagetools wordcount lineheight addfile"
				],
				content_style: "body {margin: 40px 2rem !important; line-height: 1.5; width:866px;} body > p {margin: 0}",
				toolbar_mode: 'wrap',
				toolbar: "| insertfile undo redo | styleselect fontselect fontsizeselect lineheight| bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image addfile",
				fontsize_formats: "8pt 10pt 12pt 14pt 16pt 18pt 20pt 22pt 24pt 30pt 32pt 34pt 36pt 38pt 40pt",
				lineheight_formats: "1 1.5 2 2.5 3 3.5 4 4.5 5",
				images_upload_handler: function(blobInfo, success) {
					const formData = new FormData();
					formData.append('file', blobInfo.blob(), blobInfo.filename());
					Axios.post(`${server.addr()}${server.api.FILE}`, formData).then((response) => {
						success("/download/" + response.data);
					});
				},
				files_upload_handler: function(fileObj, success) {
					const formData = new FormData();
					formData.append('file', fileObj);
					Axios.post(`${server.addr()}${server.api.FILE}`, formData).then((response) => {
						success("/download/" + response.data);
					});
				},
				setup: function(editor) {
					editor.on('init', function() {
						editor.setContent(that.popupData.content);
					});
					editor.on("change", function() {
						that.popupData.content = editor.getContent();
					})
				}
			}).then((r) => {this.editorContent = r[0]});
		},
		patchPopup: async function() {
			try {
				this.popupData.posCenterEnable = this.popupData.posCenterEnable ? 1 : 0;
				await Axios.patch(`${server.addr()}${server.api.POPUP}/${this.popupData.popupId}`, this.popupData);

				this.$emit("onDone", {
					msg: "수정되었습니다.",
					fn: () => { this.$emit("onRefresh"); this.$emit("close"); }
				});
			} catch(e) { e }
		}
	},
	watch: {
		"popup": function(val) {
			this.popupData = JSON.parse(JSON.stringify(val));
		}
	}
}
</script>